<template>
    <div v-if="aboutMe" class="col-12 mb-4">
        <div class="container-box">
            <div class="container-box-title">{{ isVenueProfile? translate.account.aboutUs : translate.account.aboutMe }}</div>
            <div class="container-box-content" id="profile-page-about">{{ aboutMe }}
                <template v-if="!isSeekingServicesProfile">
                    <br> {{ translate.account.aboutMeAdditionalText }}
                </template>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    computed: {
        ...mapState(['translate','isSeekingServicesProfile'])
    },
    props: {
        aboutMe: {},
        showAdditionalText:{default:false},
        isVenueProfile: {
            default: false
        }
    }
}
</script>
